import { BidFileTypes } from "../enums/global-enum-constant";

export class TblBidFileName {
    id?: number;
    empId?: number;
    fieldId?: string;
    bidFiles?: BidFiles[] = [];
  }

  export class BidFiles {
    fileName: string;
    fileType: BidFileTypes
}